var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _ellipse2, _path75, _path76, _path77, _path78, _path79, _path80, _g2, _path81, _g3, _g4, _path82, _path83, _g5, _path84;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 445.56 507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-2",
    x1: -40.5,
    y1: 494.17,
    x2: 179.36,
    y2: 340.74,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-5",
    x1: 210.1,
    y1: 427.39,
    x2: 227.42,
    y2: 427.39,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 157.29,
    x2: 445.56,
    y2: 157.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e98f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6242fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 307.69,
    y1: 130.91,
    x2: 177.51,
    y2: 317.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 307.69,
    y1: 130.91,
    x2: 177.51,
    y2: 317.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 307.69,
    y1: 130.91,
    x2: 177.51,
    y2: 317.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 307.69,
    y1: 130.91,
    x2: 177.52,
    y2: 317.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 249.29,
    y1: 213.75,
    x2: 345.02,
    y2: 160.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 39.03,
    y1: 175.81,
    x2: 53.21,
    y2: 167.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 43.05,
    y1: 164.67,
    x2: 55.58,
    y2: 157.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 20.24,
    y1: 234.09,
    x2: 52.06,
    y2: 216.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 36.86,
    y1: 207.13,
    x2: 36.86,
    y2: 176.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76b0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 23.54,
    y1: 179.23,
    x2: 28.63,
    y2: 176.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 19.14,
    y1: 169.18,
    x2: 25.4,
    y2: 165.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4",
    x1: -40.62,
    y1: 493.98,
    x2: 179.23,
    y2: 340.56,
    gradientTransform: "rotate(89.69 93.292 400.528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006bf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 81.7,
    y1: 345.73,
    x2: 91.02,
    y2: 340.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 78.92,
    y1: 340.54,
    x2: 96.79,
    y2: 330.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch",
    x1: 83.68,
    y1: 370.56,
    x2: 105.64,
    y2: 370.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3dbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76b0f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2",
    x1: 82.13,
    y1: 380.4,
    x2: 101.08,
    y2: 380.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76b0f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 107.18,
    y1: 352.88,
    x2: 118.48,
    y2: 346.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 103.46,
    y1: 346.69,
    x2: 110.58,
    y2: 342.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -125.78,
    y1: 491.95,
    x2: 418.95,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-2",
    x1: 15.8,
    y1: 407.27,
    x2: 38.61,
    y2: 407.27,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy",
    x1: 50.96,
    y1: 423.33,
    x2: 37.1,
    y2: 395.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3dbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ec5f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-3",
    x1: 43.15,
    y1: 376.98,
    x2: 35.94,
    y2: 375.51,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 38.95,
    y1: 386.82,
    x2: 49.37,
    y2: 381.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 33.32,
    y1: 384.67,
    x2: 49,
    y2: 375.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 37.49,
    y1: 392.53,
    x2: 42.6,
    y2: 389.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-4",
    x1: -46.98,
    y1: 484.87,
    x2: 172.87,
    y2: 331.44,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-2",
    x1: 161.07,
    y1: 332.67,
    x2: 147.21,
    y2: 304.42,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-5",
    x1: 153.25,
    y1: 286.32,
    x2: 146.05,
    y2: 284.84,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 149.06,
    y1: 296.16,
    x2: 159.48,
    y2: 290.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 143.42,
    y1: 294,
    x2: 159.11,
    y2: 285.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 147.6,
    y1: 301.87,
    x2: 152.71,
    y2: 299.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 337.75,
    y1: 425.82,
    x2: 372.05,
    y2: 406.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 355.52,
    y1: 358.55,
    x2: 361.1,
    y2: 355.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 351.64,
    y1: 348.35,
    x2: 358.82,
    y2: 344.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 354.48,
    y1: 395.72,
    x2: 354.48,
    y2: 360.31,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 333.92,
    y1: 352.94,
    x2: 341.24,
    y2: 348.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 338.98,
    y1: 363.5,
    x2: 344.88,
    y2: 360.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-3",
    x1: 219.72,
    y1: 420.15,
    x2: 238.98,
    y2: 420.15,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy-4",
    x1: 214.47,
    y1: 423.64,
    x2: 233.2,
    y2: 423.64,
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f8f9}.cls-3{fill:#c3dcee}.cls-9{fill:#1e98f4}.cls-11{opacity:.5}.cls-5{fill:#fff}.cls-6{fill:#e5eeff}.cls-10{fill:#76b0f7}.cls-17{fill:#0044ae;opacity:.2}.cls-18{fill:#9df}.cls-19{fill:#55beff}.cls-22{fill:#6242fc}.cls-29{fill:url(#linear-gradient-15)}.cls-30{fill:#006bf3}.cls-34{fill:url(#linear-gradient-18)}.cls-48{isolation:isolate}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.29 0h435v507h-435a10 10 0 0 1-10-10V10a10 10 0 0 1 10-10Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient)"
    },
    d: "M0 0h445.29v507H0z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m215.05 109.27.07.17c0-.06-.05-.11-.07-.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.36 0h-10.24c28.88 19.6 50.11 56.49 68.27 96.63.19.43.38.86.58 1.29l1.65 3.69q3 6.78 5.91 13.65l.13.3c11.5 27.13 21.94 54.73 32.64 78.69q2.11.87 4.26 1.89v-8.4C417.64 124.3 391.1 37.19 342.36 0Z",
    style: {
      opacity: 0.5,
      fill: "#1e98f4"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.52 21.48-1.09.57ZM73.09 22.23l-.94.46ZM71.87 22.82l-1.2.55ZM70.39 23.48l-1 .41ZM215.12 109.44c12.51 27.87 28.59 53.75 58.26 71.26-29.67-17.51-45.75-43.39-58.26-71.26ZM276.29 182.38c-.59-.32-1.16-.65-1.74-1 .58.33 1.15.66 1.74 1 57.76 32 91.14 6 131.94 8.68-40.8-2.69-74.18 23.35-131.94-8.68ZM75.74 20.79l-1.14.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.53 115.26q-2.91-6.86-5.91-13.65L401 97.92c-.2-.43-.39-.86-.58-1.29C382.23 56.49 361 19.6 332.12 0h-53.64c-24.7 24.34-36.31 82.45-58.21 105 12.73 28.64 29.06 55.29 59.81 73 .62.36 1.25.72 1.89 1.07 70.06 38.85 104.26-7.73 159.33 15.17-10.7-24-21.14-51.56-32.64-78.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.15 25.06-1 .31ZM30.54 22.5l-1.73-.69ZM28.23 21.57l-1.62-.7ZM26.2 20.68l-2-.93ZM23.67 19.51c-.54-.26-1.09-.53-1.63-.81.54.3 1.09.55 1.63.81ZM21.44 18.4l-2.13-1.1ZM37 24.7ZM32.69 23.3c-.63-.22-1.27-.46-1.91-.7.64.24 1.28.48 1.91.7ZM34.67 24c-.48-.16-1-.32-1.46-.5.49.16.98.32 1.46.5ZM38.82 25.2l-1.55-.42ZM0 1.22Q11.87 7 25 14c23.87 12.76 40.56 11.56 53.72 5 8.08-5.38 14.84-12.53 21.35-19H0M19.31 17.3c-1.94-1-3.85-2.06-5.75-3.05q2.84 1.49 5.75 3.05ZM11.69 13.28l-3.75-1.95ZM5.73 10.21 2.44 8.53ZM42.85 26.12l-1.72-.35ZM60.29 26.48l-1.4.22ZM58.52 26.74l-1.12.13ZM57 26.91q-.73.07-1.47.12.74-.03 1.47-.12ZM61.7 26.22l-1.16.22ZM67.79 24.51ZM63.23 25.88l-1.13.26ZM55.39 27c-.45 0-.91 0-1.36.06.45.02.91 0 1.36-.06ZM64.79 25.47l-1.32.35ZM48.37 26.91c-.51-.05-1-.1-1.55-.17.52.07 1.04.12 1.55.17ZM44.61 26.43l-1.32-.23ZM46.74 26.74l-1.66-.23ZM53.58 27.1ZM69.05 24l-1.15.43ZM52 27.1c-.51 0-1 0-1.55-.05.55.03 1.06.04 1.55.05ZM40.79 25.69l-1.45-.35ZM50.1 27q-.63 0-1.26-.09.63.09 1.26.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m.13 7.38 2.31 1.15 3.29 1.68 2.21 1.12 3.75 1.95 1.87 1c1.9 1 3.81 2 5.75 3.05l2.13 1.1.6.3c.54.28 1.09.55 1.63.81l.5.24 2 .93.41.19 1.62.7.58.24 1.73.69.24.1c.64.24 1.28.48 1.91.7l.52.18c.49.18 1 .34 1.46.5l.49.16c.62.2 1.23.39 1.84.56l.27.08 1.55.42.52.14 1.45.35.34.08 1.72.35.44.08 1.32.23.47.08 1.66.23h.08c.52.07 1 .12 1.55.17h.47q.63.06 1.26.09h.37c.52 0 1 0 1.55.05h2c.45 0 .91 0 1.36-.06h.14q.73 0 1.47-.12h.4l1.12-.13h.37l1.4-.22h.25l1.16-.22.4-.08 1.13-.26.24-.06 1.32-.35.35-.1 1-.31.36-.11c.43-.14.85-.28 1.28-.44h.11l1.2-.62.36-.15 1-.41.28-.11 1.2-.55.28-.13.94-.46.34-.18 1.09-.57h.08l1.14-.65c1-.58 2-1.2 3-1.84C65.56 25.56 48.87 26.76 25 14Q12 7.05.27 1.35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282 179.08c-.64-.35-1.27-.71-1.89-1.07-30.75-17.75-47.08-44.4-59.81-73C204 68.43 193.64 28.66 166.63 0h-8.91c29.7 29.11 40.19 71 57.33 109.27l.07.17c12.51 27.87 28.59 53.75 58.26 71.26l1 .61.15.09c.58.33 1.15.66 1.74 1 58.67 32.53 92.19 5.14 133.89 8.83 11 1 22.6 4.13 35.38 11.12v-6.19q-2.15-1-4.26-1.89C386.23 171.35 352 217.93 282 179.08Z",
    style: {
      opacity: 0.3,
      fill: "#1e98f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53.5c109.64 63.3 285.54 168.69 445.56 261.08V202.33c-12.78-7-24.37-10.14-35.38-11.12-41.7-3.69-75.22 23.7-133.89-8.83-.59-.32-1.16-.65-1.74-1l-.15-.09-1-.61c-29.67-17.51-45.75-43.39-58.26-71.26l-.07-.17C197.91 71 187.42 29.11 157.72 0h-57.65C93.56 6.47 86.8 13.62 78.72 19c-1 .64-2 1.26-3 1.84l-1.14.65h-.08l-1.09.57-.34.18-.94.46-.28.13-1.2.55-.28.11-1 .41-.36.15-1.15.43h-.11c-.43.16-.85.3-1.28.44l-.36.11-1 .31-.35.1-1.32.35-.24.06-1.13.26-.4.08-1.16.22h-.25l-1.4.22h-.37l-1.12.13h-.4q-.73.07-1.47.12h-.14c-.45 0-.91 0-1.36.06h-2c-.51 0-1 0-1.55-.05h-.37q-.63 0-1.26-.09h-.47c-.51-.05-1-.1-1.55-.17h-.08l-1.66-.23-.47-.08-1.32-.23-.44-.08-1.72-.35-.34-.08-1.45-.35-.52-.14-1.55-.42-.25.03c-.61-.17-1.22-.36-1.84-.56l-.49-.14c-.48-.16-1-.32-1.46-.5l-.52-.18c-.63-.22-1.27-.46-1.91-.7l-.24-.1-1.73-.69-.58-.24-1.62-.7-.41-.19-2-.93-.5-.24c-.54-.26-1.09-.53-1.63-.81l-.6-.3-2.13-1.1c-1.94-1-3.85-2.06-5.75-3.05l-1.87-1-3.78-1.94-2.21-1.12-3.29-1.68L.13 7.38",
    style: {
      fill: "url(#linear-gradient-2)",
      opacity: 0.3
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 258.14,
    cy: 333.61,
    rx: 17.48,
    ry: 55.95,
    transform: "rotate(-63.46 258.136 333.61)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.25 507h6.32l260.94-150.29-30.86-15.28L0 477.84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M169 147.17c.09-30.83 11-52.54 28.6-62.77l-16.66 9.68c-17.59 10.23-28.51 31.94-28.6 62.77C152.15 218.92 196 294.78 250 326l16.66-9.68C212.61 285.1 168.81 209.23 169 147.17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m191.89 182-16.66 9.68c8.3 43.45 38.65 89.68 74.8 110.55l16.66-9.68c-36.15-20.87-66.5-67.11-74.8-110.55Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173 168.78a119.51 119.51 0 0 0 2.24 22.9l16.65-9.68a119.51 119.51 0 0 1-2.24-22.9c0-17.67 4.61-31.55 12.42-40.91l-16.66 9.68c-7.81 9.37-12.41 23.24-12.41 40.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m185.41 127.87 12.85-7.47 1.9-1.1 1.69-1a2.53 2.53 0 0 0 .22-.13c.31-.37.62-.73.94-1.09l-16.66 9.68c-.35.38-.63.74-.94 1.11ZM250.14 264.54c7.13 4.12 13.89 6.08 19.88 6.09l16.66-9.63c-6 0-12.75-2-19.88-6.09Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.35 126.78 203 117.1l.55-.6-16.66 9.68Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M201.79 166.11c.05-20.51 7.32-35 19-41.76L204.15 134c-11.7 6.8-19 21.24-19 41.75-.12 41.28 29 91.74 64.94 112.49l16.66-9.69c-35.95-20.7-65.08-71.16-64.96-112.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.44 178c0-13.17 4.43-22.68 11.61-27.63l-16.66 9.68c-7.18 4.95-11.57 14.46-11.61 27.64-.08 28.19 19.82 62.66 44.36 76.82l16.66-9.68c-24.54-14.13-44.44-48.6-44.36-76.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M234.58 185c0-10.18 3.64-17.35 9.45-20.73L227.37 174c-5.81 3.38-9.42 10.55-9.45 20.74-.06 20.5 14.41 45.56 32.26 55.86l16.66-9.68C249 230.61 234.52 205.54 234.58 185Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m250.24 226.86.41.22 16.66-9.68-.41-.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.65 227.08a11.74 11.74 0 0 0 1.95.86l16.66-9.68a11.74 11.74 0 0 1-1.95-.86ZM266.69 292.55 250 302.23c21.44 12.38 40.9 13.52 55 5.35l16.66-9.68c-14.07 8.16-33.53 7.03-54.97-5.35ZM286 261.34l-1.07.62-1.13.66-2.87 1.66-10.93 6.35a23 23 0 0 0 11.76-3l16.66-9.68a23 23 0 0 1-11.76 3 3.25 3.25 0 0 0-.66.39Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m269.26 218.26-16.66 9.68a7.07 7.07 0 0 0 6-.27l16.62-9.67a7.07 7.07 0 0 1-5.96.26Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M266.62 316.29 250 326c27.18 15.69 51.84 17.12 69.67 6.76l16.66-9.68c-17.87 10.33-42.53 8.92-69.71-6.79ZM266.84 240.91l-16.66 9.68c9 5.18 17.12 5.66 23 2.24l16.66-9.69c-5.84 3.42-14.03 2.95-23-2.23Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.24 197c0-3.68 1.32-6.28 3.42-7.5L242 199.15c-2.1 1.22-3.41 3.82-3.42 7.5 0 7.42 5.21 16.48 11.66 20.21l8.33-4.84 8.33-4.84c-6.45-3.73-11.68-12.8-11.66-20.18Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m266.73 278.59-16.66 9.69c18.08 10.43 34.49 11.39 46.34 4.5l16.66-9.68c-11.85 6.9-28.26 5.9-46.34-4.51Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m217.39 160.08 8.7-5.06 4-2.31 2.06-1.2 1-.57c.28-.16.66-.37.93-.54.45-.31.92-.61 1.39-.89l-16.66 9.69c-.5.27-.97.57-1.42.88ZM186.9 126.18l14.49-8.42 1.08-.63.83-.48a1.35 1.35 0 0 0 .26-.15 37.76 37.76 0 0 1 8.67-6.94l-16.66 9.68a38 38 0 0 0-8.67 6.94ZM227.37 174a15.92 15.92 0 0 1 4.92-1.84l16.71-9.7a16.2 16.2 0 0 0-4.92 1.85ZM296.41 292.78l16.66-9.68a31.29 31.29 0 0 0 4.28-3l-16.66 9.68a31.29 31.29 0 0 1-4.28 3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M258.66 189.47 242 199.15c2.13-1.23 5.07-1.06 8.32.81l16.68-9.68c-3.27-1.87-6.21-2.05-8.34-.81ZM267 190.28 250.32 200c6.45 3.73 11.68 12.79 11.66 20.2 0 3.69-1.31 6.28-3.42 7.51l16.66-9.71c2.11-1.22 3.41-3.81 3.42-7.5.02-7.43-5.21-16.5-11.64-20.22Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m273.19 252.82 16.66-9.68a18.13 18.13 0 0 0 7.86-10.23l-16.66 9.68a18.13 18.13 0 0 1-7.86 10.23Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m281.05 242.59 9.19-5.34 3.73-2.17 3.31-1.92c.13-.08.34-.14.43-.25a33 33 0 0 0 1.59-10.5l-16.66 9.68a33 33 0 0 1-1.59 10.5ZM249 162.46a7.74 7.74 0 0 0-1 .56l-2 1.17c-.63.37-1.47.86-2.11 1.22l-1.07.63-2.18 1.27q-4.17 2.41-8.33 4.84c5.17-1 11.4.21 18.1 4.07l16.66-9.68c-6.72-3.86-12.95-5.11-18.07-4.08Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m235.44 149.52-16.66 9.68c8.09-4.7 19.3-4 31.65 3.08l16.66-9.69c-12.35-7.13-23.56-7.78-31.65-3.07Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m267.05 166.54-16.66 9.68c17.84 10.31 32.31 35.37 32.25 55.87l16.66-9.68c.06-20.5-14.41-45.57-32.25-55.87ZM220.81 124.36 204.15 134c11.85-6.89 28.26-5.94 46.34 4.5l16.66-9.68c-18.08-10.4-34.49-11.36-46.34-4.46Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m267.09 152.59-16.66 9.69c24.53 14.16 44.43 48.63 44.35 76.82 0 14-5 23.87-13 28.52l16.66-9.68c8-4.65 12.95-14.51 13-28.52.08-28.19-19.82-62.66-44.35-76.83ZM212.22 109.57l-16.66 9.68c14.06-8.18 33.52-7 55 5.34l16.66-9.68c-21.48-12.39-40.94-13.52-55-5.34Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m197.59 84.4-16.66 9.68c17.82-10.35 42.49-8.92 69.67 6.77l16.66-9.68C240.08 75.48 215.41 74 197.59 84.4ZM267.15 128.86l-16.66 9.68c35.93 20.74 65.06 71.21 64.95 112.48-.05 17.89-5.58 31.16-14.75 38.77l15.53-9 .56-.32.5-.29h.07c9.17-7.62 14.7-20.89 14.75-38.77.11-41.35-29.02-91.81-64.95-112.55Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m267.19 114.91-16.66 9.68c42.62 24.61 77.19 84.47 77 133.45-.07 24.33-8.69 41.46-22.57 49.53l16.66-9.68c13.88-8.07 22.5-25.2 22.57-49.54.19-48.97-34.38-108.84-77-133.44Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.6 100.85c-54-31.18-98.1-6.06-98.27 56S196 294.78 250 326s98.1 6 98.27-56-43.66-138-97.67-169.15Zm-.6 201.38c-42.62-24.61-77.18-84.47-77-133.45s34.92-68.8 77.54-44.19 77.19 84.47 77 133.45-34.89 68.8-77.54 44.19Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.39 176.22c-17.85-10.3-32.41-2-32.47 18.51s14.41 45.56 32.26 55.86 32.4 2 32.46-18.5-14.41-45.56-32.25-55.87Zm-.15 50.64c-6.45-3.73-11.68-12.79-11.66-20.21s5.29-10.41 11.74-6.69S262 212.75 262 220.16s-5.31 10.42-11.76 6.7Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.49 138.54c-35.93-20.75-65.25-4-65.36 37.25s29 91.74 64.94 112.49 65.25 4 65.37-37.26-29.02-91.74-64.95-112.48Zm-.35 126c-24.54-14.16-44.44-48.63-44.36-76.82s20.11-39.61 44.65-25.44 44.43 48.63 44.35 76.82-20.11 39.61-44.64 25.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.32 200c-3.2-1.85-6.11-2-8.23-.86-.15.08-.29.17-.43.26-1.91 1.31-3.07 3.82-3.08 7.29 0 7 4.66 15.5 10.62 19.56l.25.16.49.31.3.18.9.48.59.27.29.12.48.18a10.71 10.71 0 0 0 1.28.36q.34.07.69.12h.11a5.78 5.78 0 0 0 .71 0c4 .09 6.68-3 6.69-8.29.02-7.39-5.21-16.45-11.66-20.14Z",
    style: {
      fill: "url(#linear-gradient-3)"
    },
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 162.28c-24.54-14.17-44.57-2.76-44.65 25.44s19.82 62.66 44.36 76.82 44.56 2.76 44.64-25.44-19.78-62.66-44.35-76.82Zm-.25 88.31c-17.85-10.3-32.32-35.36-32.26-55.86s14.62-28.81 32.47-18.51 32.31 35.37 32.25 55.87-14.64 28.8-32.46 18.5Z",
    style: {
      fill: "url(#linear-gradient-4)"
    },
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.53 124.59c-42.62-24.59-77.41-4.78-77.53 44.19s34.42 108.84 77 133.45S327.44 307 327.58 258s-34.43-108.8-77.05-133.41Zm-.46 163.69c-35.93-20.75-65.06-71.21-64.94-112.49s29.43-58 65.36-37.25 65.06 71.21 64.95 112.46-29.44 58-65.37 37.28Z",
    style: {
      fill: "url(#linear-gradient-5)"
    },
    className: "cls-11"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.74 210.05c7.38 20.14 11.55 40.68 11.49 59.91-.08 30.83-11 52.55-28.6 62.77l16.66-9.68c17.59-10.23 28.52-31.94 28.6-62.77.06-19.23-4.11-39.78-11.49-59.91ZM267.26 91.17l-16.66 9.68c37.28 21.53 69.69 64.33 86.14 109.2l16.66-9.68c-16.4-44.87-48.86-87.68-86.14-109.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.64 86.9c-29.41-17-57.09-19.78-77.95-7.89s-32.41 37.05-32.5 70.84 11.26 72.17 32 108.07 48.34 65 77.74 82 57.1 19.78 78 7.89 32.4-37 32.5-70.84-11.27-72.17-32-108.07-48.38-65.02-77.79-82ZM250 326c-54-31.19-97.81-107.05-97.63-169.12s44.26-87.18 98.27-56S348.41 207.9 348.23 270 304 357.15 250 326Z",
    style: {
      fill: "url(#linear-gradient-6)"
    },
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3 77.22c-29.41-17-57.09-19.78-78-7.89L172.69 79c20.86-11.89 48.54-9.08 77.95 7.89s57 46.1 77.75 82 32.08 74.28 32 108.07-11.64 58.95-32.5 70.84l16.66-9.68c20.86-11.89 32.4-37 32.5-70.84s-11.27-72.17-32-108.07-48.34-65.01-77.75-81.99Z",
    style: {
      opacity: 0.8,
      fill: "url(#linear-gradient-7)"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.74 210.05 238.58 218l-3.5 34.84 1.39 78.39q6.65 4.77 13.45 8.71a138.06 138.06 0 0 0 13.65 6.92l4.84 1-2.41-48.99 12 7.85Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M9.78 433 0 438.5v46l49.08-28.69c81.87-47.26 156.67-117.91 200.08-189L209.86 244C166.44 315.06 91.64 385.7 9.78 433Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M49.08 455.81 0 484.5v6l49.1-28.78a631.81 631.81 0 0 0 116.08-87c35.55-33.6 65.8-70.11 87.47-105.58l-3.49-2.35C205.75 337.9 131 408.55 49.08 455.81ZM246.8 206.69l13.15 76.65 5.62 1.56-13.15-76.65-5.62-1.56z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m190.29 237.72 69.66 45.62-13.15-76.65-56.51 31.03z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M12.29 310.85a1.4 1.4 0 0 0 .78 1L35.67 325a4.18 4.18 0 0 0 3.79 0l22.06-12.7a1.33 1.33 0 0 0 .78-1.1v-63.5l-50-.41Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.29 310.41a1.41 1.41 0 0 0 .78 1l22.6 13.13a4.18 4.18 0 0 0 3.79 0l22.06-12.73a1.33 1.33 0 0 0 .78-1.1v-63.5l-50-.41Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.52 248.36-22.06 12.73a3.86 3.86 0 0 1-1.89.45 3.79 3.79 0 0 1-1.9-.46L13.07 248a1.33 1.33 0 0 1-.78-1.1v.7a2.19 2.19 0 0 0 .67.6l22.59 13.12a4.41 4.41 0 0 0 4 0l22.06-12.73a2 2 0 0 0 .67-.59v-.7a1.33 1.33 0 0 1-.76 1.06Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.52 246.16 38.93 233a4.18 4.18 0 0 0-3.79 0l-22.06 12.75a1.16 1.16 0 0 0 0 2.2l22.6 13.13a4.18 4.18 0 0 0 3.79 0l22.06-12.73a1.16 1.16 0 0 0-.01-2.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.19 162.55c-.78-.32-2-.33-3.34 1.39-1.53 2-3.12 6.06-4.45 8.8-2.46 5-1.88 7.74.1 8.59s4.24-3.86 5.4-6.41c1.55-3.38 3.99-11.67 2.29-12.37Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M52.39 147.23c-1.32-.61-1.84 0-2 1.13a5.65 5.65 0 0 1-.3 1.36s.06-1.61-.43-1.8-.62 1.33-.43 3.15.4 2.8.4 2.8l2.07 1.87a14.38 14.38 0 0 0 1.41-3.81c.89-3.39.55-4.11-.72-4.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.27 152.36c-.2.63-1.32 4.65-2.42 9.44s-1.61 7.2-1.61 7.2 2.67 3.26 4 .58c0 0 4.25-12.44 3.84-16.53-.08-.61-2.56-1.58-3.81-.69Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M47.6 241c-6.15-3.54-16.14-3.53-22.32 0s-6.22 9.35-.07 12.89 16.14 3.53 22.32 0 6.22-9.34.07-12.89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M31.59 248.7a16 16 0 0 0-3.35-.76 2.36 2.36 0 0 0-1.89 1.75c-.33 1.51 6.35 5.81 9.92 5s-2.71-5.34-4.68-5.99ZM43.86 241.39a16.71 16.71 0 0 0-3.35-.76 2.36 2.36 0 0 0-1.89 1.75c-.32 1.52 6.35 5.82 9.92 5s-2.71-5.38-4.68-5.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.83 231s-1.13 16-1.13 17c0 2.42 4 2.71 4.14 1.69s3.49-20.55 3.49-20.55l2-15.62 1.31 12.26S40 239.09 40.14 241s4 3.27 4 1.68 1.17-38.94 1.17-38.94l-16.54 3.35Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.23 175.52c-2.71-1.36-13.38 4.23-13.38 4.23-4.08 1.95-1.11 27.32-1.11 27.32s1.38 1.3 6.19 1.3 10.32-4.2 10.32-4.2.91-11.77.76-18.65-.08-8.63-2.78-10Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 170c-1.41-1.62-2.67-1.52-3.43-1.15-1.64.82 1.37 8.91 3.14 12.18 1.34 2.47 3.93 7 5.84 6s2.31-3.71-.5-8.57c-1.52-2.6-3.39-6.46-5.05-8.46Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M21.13 155.31c-.45-.12-.6.75-.6.75a5.39 5.39 0 0 1-.39-1.34c-.24-1.09-1.07-2-2.07-1s-1.06 2.11-.4 4.74a8.89 8.89 0 0 0 1.67 3.7l1.94-2s.13-1 .2-2.82.1-1.9-.35-2.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.53 158.64c-1.31-.8-3.75.34-3.77 1-.13 4.1 5 16.22 5 16.22 1.53 2.57 4-.86 4-.86s-.68-2.42-2.11-7.11-2.88-8.64-3.12-9.25Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.59 172.69v5.08a2.75 2.75 0 0 0 3 1.45c2.13-.42 2.52-2.94 2.21-4.28s-5.21-2.25-5.21-2.25Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M33.4 169.08c.16 4.13 2.4 7.95 7 7.13s3.72-9.12 3.72-9.12c-1.5-8.25-11.18-3.26-10.72 1.99Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M45 164.57c-.43-.31-1-.38-1.41-.74s-.56-1.09-.94-1.57a2.66 2.66 0 0 0-2.64-.67 20.76 20.76 0 0 1-2.77.69h-1.5a2.34 2.34 0 0 0-1.41.44 2.76 2.76 0 0 0-.76 1.8 4.26 4.26 0 0 1-.53 1.9c-.25.38-.65.66-.79 1.09a2 2 0 0 0 0 1.07l.33 1.67c.18.94.36 1.88.55 2.82a2.09 2.09 0 0 0 .49 1.17.82.82 0 0 0 .87.15l.07-.06c.14-.15.08-.38.11-.6a13 13 0 0 1 .39-1.64 9.41 9.41 0 0 1 1.3-3.33c1-1.3 1-1.68 1-1.68l.59.39a9 9 0 0 0 1.54.73 6.68 6.68 0 0 0 4.35 0 2.84 2.84 0 0 0 1.67-1.53 1.83 1.83 0 0 0-.51-2.1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.42 169.52c-.82 1.33.18 2.46.82 3.1s1.73-.84.81-2.32c0 0-.81-2.12-1.63-.78Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.29,
    cy: 400.53,
    rx: 9.23,
    ry: 15.99,
    transform: "rotate(-89.69 93.289 400.53)",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4)",
      opacity: 0.3
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97 343.82a5.51 5.51 0 0 1-1.46 0s.85-.39.6-.81-.33-.37-2.17.19-2.82 1-2.82 1l-1.53 2.5a9.42 9.42 0 0 0 4.22.71c2.85 0 3.92-.36 4.72-1.67s-.41-1.96-1.56-1.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.07 338.76s-4.13 2.59-1.66 4.55c0 0 6.39 3.44 10.69 3.89.7.07 2.23-2.32 1.58-3.79-.6-.34-10.61-4.65-10.61-4.65Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M87.47 331.81c-3 2.53-9 9.32-7.74 10.76.6.65 1.81 1.23 3.8.17 2.37-1.25 5.7-4.37 8.2-6.38 4.61-3.69 5.26-6.52 3.76-8.21s-5.77 1.76-8.02 3.66Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M87.47 331.81c-3 2.53-9 9.32-7.74 10.76.6.65 1.81 1.23 3.8.17 2.37-1.25 5.7-4.37 8.2-6.38 4.61-3.69 5.26-6.52 3.76-8.21s-5.77 1.76-8.02 3.66Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M85.25 399.83a16.51 16.51 0 0 0-3.34 1.37 2.46 2.46 0 0 0-.57 2.64c.63 1.51 9 1.18 11.55-1.7s-5.55-2.95-7.64-2.31ZM98.25 381.84a17 17 0 0 0-2.82 2.27 2.48 2.48 0 0 0 .2 2.7c1 1.26 9-1.43 10.6-4.91s-6.15-1.26-7.98-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89 358.37-4.63-2s-1.87 6.23.66 9.57c1.26 1.65 13.2 6.1 13.2 6.1L96 384.14s3 2.1 5.12-1.71c1.3-4.72 5-14.53 4.45-15.79S89 358.37 89 358.37Z",
    style: {
      fill: "url(#New_Gradient_Swatch)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 358.36c-.87.7-2.43 6.71-2 11.47-1.63 10.57-5.9 31.6-5.9 31.6s2.14 4.05 4.89-1.23 14.09-38.2 14.09-38.2-8.44-5.76-11.08-3.64Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_2)"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.83 327.72c-3.12.69-3.5 2.5-5.44 9.48s-4 19.22-4 19.22 4.52 5.72 9.43 7 6.66.28 6.66.28 9.6-25.11 5.95-28.16c-.05-.04-9.43-8.54-12.6-7.82Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M118.16 340.53a5.44 5.44 0 0 1-.7 1.28s0-.93-.45-.9-.47.13-.8 2-.42 2.94-.42 2.94l1.55 2.5a9.37 9.37 0 0 0 2.54-3.45c1.25-2.55 1.44-3.65.63-5s-1.85-.45-2.35.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.86 344.17c-.58.38-8.94 7.37-8.94 7.37s.45 4.85 3.31 3.54c0 0 6-4.16 8.3-7.79.37-.59-1.06-3.04-2.67-3.12Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M103.51 334.77c-2.19.58-1 6-.35 8.82.9 3.81 4.23 12.27 6.1 11.75.85-.24 1.91-1 1.87-3.31 0-2.68-1.33-7-2-10.19-1.21-5.78-3.44-7.65-5.62-7.07Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M103.51 334.77c-2.19.58-1 6-.35 8.82.9 3.81 4.23 12.27 6.1 11.75.85-.24 1.91-1 1.87-3.31 0-2.68-1.33-7-2-10.19-1.21-5.78-3.44-7.65-5.62-7.07Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m98.86 324.07-1.32 5.18a4.37 4.37 0 0 0 4.26 2.5 12.54 12.54 0 0 0 1.68-5.37c.03-1.44-4.62-2.31-4.62-2.31Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M95.62 321.81c.17 4.34 2.53 8.36 7.36 7.5s3.9-9.61 3.9-9.61c-1.57-8.7-11.75-3.41-11.26 2.11Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M102.66 314.77c-6.26-1-7.91 4.68-7.91 6.42S96 329 98.46 329s4.67-2.87 4.67-2.87c-.61-3.09 2.63-4.3 4.14-6s1.65-4.39-4.61-5.36Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.56 322.76c-.86 1.41.19 2.6.86 3.27s1.82-.89.86-2.44c0 0-.86-2.23-1.72-.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.67 427.72c-6.27-3.62-16.39-3.63-22.62 0s-6.2 9.44.07 13.06 16.39 3.64 22.62 0 6.19-9.44-.07-13.06Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4-2)",
      opacity: 0.2
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M49.88 429.89a14.14 14.14 0 0 0-2.77 1.48 2.15 2.15 0 0 0-.26 2.34c.68 1.24 7.87.21 9.84-2.5s-5.06-2.06-6.81-1.32ZM18.48 426.67a14.91 14.91 0 0 0-2.86-1.31 2.16 2.16 0 0 0-2 1.2c-.58 1.3 4.58 6.42 7.93 6.35s-1.43-5.28-3.07-6.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.23 392.72c-.18 3.76-1.47 20-1.47 20L15.8 426s.23 2.84 2.2 2c.84-.37 13.7-9.63 15.49-12.59s5.12-25.17 5.12-25.17l-6.16-3.78a9.7 9.7 0 0 0-3.22 6.26Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_2-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 388.94c-2.41-.78-5.62 1.15-5.62 1.15s-2.62 2.67-.54 9.42c.76 2.18 6.9 12.41 6.9 12.41l5.81 19.67s2.81.89 3-.94c.08-.89-1.76-12.65-3.08-19.17s-4.02-21.76-6.47-22.54Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41 366.17c-1.75-.37-1.89 1.52-1.89 1.52-.87 3.7-1.28 12.24 1 16.32 2 3.56 3.22.1 3.45-.27a63.49 63.49 0 0 0 .59-9.87c.05-4.82-1.41-7.33-3.15-7.7Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4-3)"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M54 382.07a3.91 3.91 0 0 1-1 .26s.52-.44.26-.69-.3-.19-1.49.57-1.77 1.24-1.77 1.24l-.57 2.07a6.89 6.89 0 0 0 3.1-.35c2-.59 2.67-1 3-2.12s-.67-1.25-1.53-.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.55 383.28 39 382c-1.4.18-.89 3.6-.89 3.6s10.7 1.24 12.21-.18.23-2.14.23-2.14Z",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M48.1 354.79s-4.59 13.83-2.67 13.51 2.93-3.4 3.72-7.77-1.05-5.74-1.05-5.74Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.56 365.83c-4.8-.85-4 8.85-3.71 11.08s.08 6.85-1.4 9.5c0 0 2.63 4.41 5.89 5.69s4.59-.68 4.6-.69c.08-1.47.11-2.57.23-3.21.55-3.09 3.09-4.33 4.63-7.36s-.25-7.78-.25-7.78-5.18-6.39-9.99-7.23Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M44.41 352.88c-3.26-.52-7.17.39-8.57 6.4s-.42 8.51-.42 8.51 4.43 3.71 7.27 3.69a10.7 10.7 0 0 0 4.89-1.2s.19-10.93 2.15-14.32a9.43 9.43 0 0 0-5.32-3.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.13 372.92c-3.17 2.1-9.33 8-10.46 12.56-1 4 2.27 2.29 2.69 2.17a62.59 62.59 0 0 0 7.21-6.76c3.33-3.48 4-6.31 3-7.78a1.57 1.57 0 0 0-2.44-.19Z",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M48.72 396.09a4.17 4.17 0 0 1-.93-.52s.68 0 .66-.32-.08-.35-1.47-.6-2.14-.33-2.14-.33L43 395.43a7 7 0 0 0 2.5 1.88c1.85.93 2.65 1.08 3.61.5s.39-1.35-.39-1.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.82 385.67c-1.14-.83-3.12 2-3.12 2s6.93 8.24 9 8.25 1.65-1.36 1.65-1.36Z",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78 337.06c-6.27-3.62-16.4-3.64-22.62 0s-6.2 9.44.07 13.06 16.39 3.63 22.62 0 6.15-9.44-.07-13.06Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4-4)",
      opacity: 0.3
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M160 339.22a14.86 14.86 0 0 0-2.77 1.49A2.13 2.13 0 0 0 157 343c.68 1.25 7.87.22 9.84-2.5s-5.1-2.01-6.84-1.28ZM128.58 336a14.7 14.7 0 0 0-2.85-1.31 2.13 2.13 0 0 0-2 1.2c-.58 1.29 4.58 6.41 7.93 6.34s-1.43-5.23-3.08-6.23Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.56 295.75a9.74 9.74 0 0 0-3.23 6.31c-.18 3.76-1.46 20-1.46 20l-12 13.24s.23 2.83 2.19 2c.85-.38 12.13-11.78 15.5-12.59 3.11-.75 5.46-24.61 5.12-25.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.14 298.28c-2.41-.79-5.63 1.15-5.63 1.15s-2.61 2.67-.53 9.42c.75 2.18 6.89 12.4 6.89 12.4l5.81 19.68s2.81.89 3-.94c.08-.9-1.76-12.66-3.08-19.17s-4.05-21.76-6.46-22.54Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51 275.51c-1.74-.37-1.89 1.52-1.89 1.52-.86 3.7-1.27 12.23 1 16.31 2 3.56 3.23.11 3.45-.26s.57-5.05.6-9.87-1.41-7.33-3.16-7.7Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4-5)"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.15 291.4a4.47 4.47 0 0 1-1 .27s.52-.44.26-.69-.3-.19-1.48.57-1.78 1.24-1.78 1.24l-.58 2.06a6.93 6.93 0 0 0 3.11-.35c2-.59 2.67-1 3-2.11s-.68-1.25-1.53-.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m160.66 292.61-11.6-1.29c-1.39.17-.88 3.6-.88 3.6s10.7 1.24 12.21-.19.27-2.12.27-2.12Z",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.2 264.13s-4.59 13.82-2.66 13.51 2.93-3.4 3.71-7.78-1.05-5.73-1.05-5.73Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M147.67 275.16c-4.8-.84-4 8.86-3.72 11.08s.09 6.85-1.39 9.51c0 0 2.63 4.41 5.89 5.68s4.58-.67 4.6-.69c.07-1.46.11-2.56.22-3.2.55-3.1 3.1-4.33 4.64-7.37s-.25-7.77-.25-7.77-5.19-6.4-9.99-7.24Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M154.51 262.21c-3.26-.52-7.16.4-8.56 6.41s-.43 8.5-.43 8.5 4.44 3.71 7.28 3.7a10.85 10.85 0 0 0 4.89-1.2s.18-10.94 2.14-14.33a9.39 9.39 0 0 0-5.32-3.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.23 282.25c-3.16 2.1-9.33 8-10.46 12.57-1 4 2.28 2.29 2.69 2.17s3.88-3.28 7.21-6.76 4-6.32 3-7.78a1.57 1.57 0 0 0-2.44-.2Z",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.83 305.43a4.17 4.17 0 0 1-.93-.52s.68 0 .66-.33-.09-.34-1.47-.6-2.15-.32-2.15-.32l-1.83 1.1a6.87 6.87 0 0 0 2.49 1.88c1.86.94 2.66 1.08 3.62.51s.39-1.35-.39-1.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.93 295c-1.14-.83-3.12 2-3.12 2s6.93 8.24 9 8.25 1.65-1.36 1.65-1.36Z",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m.1 333.65.34.64 22.97-16.01-.35-.64L.1 333.65zM284.29 398l-105.81 59.87.36.63 105.83-59.86a5.61 5.61 0 0 1 5.14-.87c1.72.84 153.75 92.78 155.29 93.71l.37-.62c-6.29-3.81-154.24-93.28-155.37-93.76a6.23 6.23 0 0 0-5.81.9ZM353.63 330.93c-1.35-1-2.07.26-2.11 1.54a6.58 6.58 0 0 1-.16 1.57s-.35-.94-.83-.71-.42.33.05 2.36.82 3.11.82 3.11l2.59 1.84a10.35 10.35 0 0 0 1.08-4.5c.18-3.07-.07-4.25-1.44-5.21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M403.27 441.59 357.86 468a9 9 0 0 1-8.17 0L304 441.59a2.87 2.87 0 0 1-1.7-2.38v1.51a2.89 2.89 0 0 0 1.7 2.38l45.7 26.39a9 9 0 0 0 8.18 0l45.41-26.39a2.9 2.9 0 0 0 1.68-2.35v-1.51a2.86 2.86 0 0 1-1.7 2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m403.25 436.86-45.71-26.39a9 9 0 0 0-8.18 0L304 436.86c-2.24 1.3-2.23 3.42 0 4.73L349.69 468a9 9 0 0 0 8.17 0l45.41-26.39c2.25-1.33 2.24-3.45-.02-4.75Z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 353.65,
    cy: 438.9,
    rx: 17.29,
    ry: 9.98,
    transform: "rotate(-.31 353.673 440.843)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.8 441c-2-1.3-10.41-3.71-8.63.06s10.34 6.67 11.46 5.31a2.68 2.68 0 0 0 .22-2.92 18 18 0 0 0-3.05-2.45ZM360.25 434.15c-2-1.3-10.41-3.71-8.63.06s10.34 6.67 11.46 5.3a2.66 2.66 0 0 0 .22-2.91 18 18 0 0 0-3.05-2.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.35 422.93s1.17 18 1.17 19.23c0 2.75 4.55 3.09 4.72 1.93s1.51-23.26 1.51-23.26l2.25-17.78.9 14.13s2.21 14.92 2.33 17.06 4.53 3.72 4.53 1.91 1.32-44.3 1.32-44.3l-18.82 3.81Z",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.52 349.15c-1.28-1.72-2.55-1.71-3.33-1.39-1.7.7.74 9 2.28 12.37 1.16 2.55 3.43 7.25 5.41 6.41s2.56-3.55.1-8.59c-1.34-2.74-2.93-6.77-4.46-8.8Z",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.1 337.57c-1.24-.89-3.76.08-3.83.73-.41 4.09 3.84 16.53 3.84 16.53 1.35 2.68 4-.58 4-.58s-.51-2.46-1.61-7.24-2.2-8.81-2.4-9.44Z",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352 355.79c-.35 1.52-.22 5 .33 6.07a4.72 4.72 0 0 0 5.12-1.48v-5.78s-5.13-.33-5.45 1.19Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M346.6 349.67s-1 9.44 4.23 10.37 7.77-3.42 7.94-8.11c.52-5.93-10.49-11.65-12.17-2.26Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M351.15 344.32c-6.76 1.06-6.6 3.83-5 5.71s5.14 3.18 4.48 6.52c0 0 2.37 3.09 5.06 3.09s4-6.52 4-8.39-1.77-7.99-8.54-6.93Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.42 353.86c-1 1.68.2 3.36.93 2.64s1.86-2 .92-3.53-1.85.89-1.85.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.72 359.76c-3.08-1.55-15.22 4.82-15.22 4.82-4.63 2.21-1.26 31.08-1.26 31.08s1.57 1.48 7.05 1.48 11.71-4.78 11.71-4.78 1.05-13.39.87-21.22-.06-9.82-3.15-11.38Z",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.79 340.38c-.48-.23-.83.71-.83.71a5.86 5.86 0 0 1-.16-1.57c0-1.28-.76-2.5-2.11-1.54s-1.63 2.14-1.44 5.21a10.18 10.18 0 0 0 1.08 4.5l2.59-1.84s.35-1.08.82-3.11.52-2.12.05-2.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.34 345c-.45 4.65 1.81 12.16 1.81 12.16 1.55 3 5.19-.78 5.19-.78s-2.42-11.53-2.65-12.24c-1.42-.98-4.28.14-4.35.86Z",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 353.83c-1.63-1.57-3.05-1.34-3.88-.87-1.82 1 1.85 9.3 4 12.57 1.59 2.47 4.66 7 6.77 5.76s2.45-4.16-.87-9c-1.88-2.65-4.11-6.6-6.02-8.46Z",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m192.91 472.34-27.4 15.82a11.18 11.18 0 0 1-10.11 0l-27.22-15.82a3.55 3.55 0 0 1-2.07-2.9v.87a3.54 3.54 0 0 0 2.06 2.91L155.4 489a11.18 11.18 0 0 0 10.11 0l27.4-15.82a3.54 3.54 0 0 0 2.1-3v-.87a3.56 3.56 0 0 1-2.1 3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m192.94 466.49-27.22-15.82a11.18 11.18 0 0 0-10.11 0l-27.4 15.82c-2.78 1.61-2.8 4.24 0 5.85l27.22 15.82a11.18 11.18 0 0 0 10.11 0l27.4-15.82c2.76-1.61 2.77-4.24 0-5.85Z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M162.82 468.83a4.77 4.77 0 0 0-4.32 0 1.31 1.31 0 0 0 0 2.49 4.75 4.75 0 0 0 4.31 0 1.31 1.31 0 0 0 .01-2.49Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.64 464.89c-4.93-2.84-13-2.82-17.91 0s-5 7.49-.06 10.34 13 2.82 17.91 0 4.98-7.49.06-10.34Zm-2.5 8.94a14.39 14.39 0 0 1-13 0c-3.58-2.07-3.56-5.44 0-7.52a14.42 14.42 0 0 1 13 0c3.63 2.06 3.61 5.44 0 7.52Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.27 461.64c-8-4.62-21.08-4.6-29.14.05s-8.11 12.2-.1 16.83 21.09 4.6 29.15 0 8.1-12.26.09-16.88Zm-2.53 15.42c-6.71 3.87-17.59 3.89-24.26 0s-6.63-10.13.08-14 17.59-3.89 24.26-.05 6.63 10.18-.08 14.05Z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m131.91 468.64 1.1 1.49 6.14-.01-1.1-1.49-6.14.01zM131.9 471.62l6.14-.01 1.11-1.49-6.14.01-1.11 1.49zM157.04 471.27l3.57-1.19-3.56-1.18-.01 2.37z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m132.11 470.26 25.17-.05v-.25l-25.16.04-.01.26z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m252.83 433.28-21.53-12.51a8.81 8.81 0 0 0-8 0l-21.67 12.51c-2.21 1.28-2.22 3.36 0 4.63l21.54 12.52a8.85 8.85 0 0 0 8 0l21.68-12.52c2.15-1.27 2.15-3.35-.02-4.63Z",
    style: {
      fill: "#08263d"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m252.81 424.39-21.68 12.51a8.85 8.85 0 0 1-8 0l-21.53-12.51a2.8 2.8 0 0 1-1.63-2.3v.69a2.8 2.8 0 0 0 1.63 2.3l21.54 12.51a8.88 8.88 0 0 0 8 0l21.67-12.51a2.83 2.83 0 0 0 1.66-2.34v-.69a2.84 2.84 0 0 1-1.66 2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m252.83 419.75-21.53-12.51a8.88 8.88 0 0 0-8 0l-21.67 12.51c-2.21 1.28-2.22 3.36 0 4.64l21.54 12.51a8.85 8.85 0 0 0 8 0l21.68-12.51c2.15-1.28 2.15-3.39-.02-4.64Z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m252.83 419.75-21.53-12.51a8.88 8.88 0 0 0-8 0l-3.24 1.87 29.6 17.09 3.15-1.81c2.19-1.28 2.19-3.39.02-4.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#New_Gradient_Swatch_copy-3)"
    },
    d: "m219.72 416.04 16.75 9.67 2.51-1.45-16.75-9.67-2.51 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#New_Gradient_Swatch_copy-4)"
    },
    d: "m214.47 419.68 16.22 9.37 2.51-1.45-16.22-9.37-2.51 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#New_Gradient_Swatch_copy-5)"
    },
    d: "m210.1 423.84 14.81 8.54 2.51-1.44-14.81-8.55-2.51 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#fff"
    },
    d: "M.29 0h445v507H.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/Login_Image.e5495c45fe9545dd1f8d5a1ff6905c19.svg";
export { ForwardRef as ReactComponent };